import { Component, ViewChild } from '@angular/core';
import { CustomFooterComponent } from "../../../../shared/components/custom-footer/custom-footer.component";
import { TabButtonComponent } from "../../../../shared/components/tab-button/tab-button.component";
import { MobileTopbarComponent } from "../../../../shared/components/mobile-topbar/mobile-topbar.component";
import { DesktopTopbarComponent } from "../../../../shared/components/desktop-topbar/desktop-topbar.component";
import { DesktopSidebarComponent } from "../../../../shared/components/desktop-sidebar/desktop-sidebar.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { ServicesSubsectionCardComponent } from "../../components/services-subsection-card/services-subsection-card.component";
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { CalendlyESGReportingDialogComponent } from "../../components/calendly-esgreporting-dialog/calendly-esgreporting-dialog.component";

@Component({
  selector: 'app-services-esgreportings-page',
  standalone: true,
  imports: [CustomFooterComponent, TabButtonComponent, MobileTopbarComponent, DesktopTopbarComponent, DesktopSidebarComponent, TranslocoPipe, CommonModule, ServicesSubsectionCardComponent, CustomButtonComponent, CalendlyESGReportingDialogComponent],
  templateUrl: './services-esgreportings-page.component.html',
  styleUrl: './services-esgreportings-page.component.css'
})
export class ServicesESGReportingsPageComponent {
  selectedSidebarItemId: number = 3;

  selectedTop: number = 1;

  // Talk to specialist dialog
  @ViewChild(CalendlyESGReportingDialogComponent) talkToSpecialistDialog!: CalendlyESGReportingDialogComponent;

  changeSelect(selection: number) {
    this.selectedTop = selection;
  }

  talkToSpecialist() {
    this.talkToSpecialistDialog.openModal();
  }
}
